import React from 'react';
import BigNumber from 'bignumber.js';
import i18next from 'i18next';


export const cc2ccy = (cc: string) => {
  switch (cc) {
    case 'HK': return 'HKD';
    case 'US': return 'USD';
    case 'CN': return 'CNH';
    case 'GB': return 'GBP';
    case 'JP': return 'JPY';
    case 'AU': return 'AUD';
    case 'NZ': return 'NZD';
    case 'CA': return 'CAD';
    case 'EU': return 'EUR';
    case 'CH': return 'CHF';
    case 'DK': return 'DKK';
    case 'NO': return 'NOK';
    case 'SE': return 'SEK';
    case 'SG': return 'SGD';
    case 'TH': return 'THB';
    case 'BN': return 'BND';
    case 'ZA': return 'ZAR';
    default: return '';
  }
}

export const ccy2cc = (ccy: string) => {
  switch (ccy) {
    case 'HKD': return 'HK';
    case 'USD': return 'US';
    case 'CNH': return 'CN';
    case 'CNY': return 'CN';
    case 'GBP': return 'GB';
    case 'JPY': return 'JP';
    case 'AUD': return 'AU';
    case 'NZD': return 'NZ';
    case 'CAD': return 'CA';
    case 'EUR': return 'EU';
    case 'CHF': return 'CH';
    case 'DKK': return 'DK';
    case 'NOK': return 'NO';
    case 'SEK': return 'SE';
    case 'SGD': return 'SG';
    case 'THB': return 'TH';
    case 'BND': return 'BN';
    case 'ZAR': return 'ZA';
    default: return '';
  }
}

export const ccy2ccLong = (ccy: string) => {
  switch (ccy) {
    case 'HKD': return 'HKG';
    case 'USD': return 'USA';
    case 'CNH': return 'CHN';
    case 'CNY': return 'CHN';
    case 'GBP': return 'GBR';
    case 'JPY': return 'JPN';
    case 'AUD': return 'AUS';
    case 'NZD': return 'NZL';
    case 'CAD': return 'CAN';
    case 'EUR': return 'DEU FRA EUZ';
    case 'CHF': return 'CHE';
    case 'DKK': return 'DNK';
    case 'NOK': return 'NOR';
    case 'SEK': return 'SWE';
    case 'SGD': return 'SGP';
    case 'THB': return 'THA';
    case 'BND': return 'BRN';
    case 'ZAR': return 'ZAF';
    default: return '';
  }
}

export const getTRDecimalPlace = (ccypairs: number) => {
  switch (ccypairs) {
    default: return 5
  }
}

export const formatValue = (value: any, color: string, dp: number, big: string) => {
  if (value) {
    if (dp && isNaN(dp))
      BigNumber.config({ DECIMAL_PLACES: dp });
    else
      BigNumber.config({ DECIMAL_PLACES: 5 });

    let bigValue = new BigNumber(value);
    value = bigValue.toString(10);

    let val;
    if (big) {
      let idx = value.indexOf(".");
      val = <span style={{ color: color }}>{value.substr(0, idx) + "."}<span style={{ fontSize: '30px' }}>{value.substr(idx + 1, 4)}</span>{value.substr(idx + 5)}</span>
    } else {
      val = <span style={{ color: color }}>{value}</span>;
    }

    return val;
  }
}

export const formatDateTime = (value: string) => {
  var d = new Date();
  let out = value;
  if (value) {
    var year = parseInt(value.substr(0, 4));
    var month = parseInt(value.substr(4, 2));
    var day = parseInt(value.substr(6, 2));
    var hour = parseInt(value.substr(8, 2));
    var min = parseInt(value.substr(10, 2));

    d = new Date(year, month - 1, day, hour, min);
  }
  out = d.toLocaleString("en-us", { year: 'numeric' }) + '/' + d.toLocaleString("en-us", { month: '2-digit' }) + '/' + d.toLocaleString("en-us", { day: '2-digit' }) + ' ' + d.toLocaleString("en-GB", { hour: '2-digit', minute: '2-digit' });

  return out;
}

export const getURLParameters = (name: string) => {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.href);
  if (results == null) {
    return "";
  }
  else {
    return results[1];
  }
}

export const fixedLength = (value: string, len: number) => {
  if (value && len) {
    let out;
    if (value.length > len) {
      out = value.substr(0, len);
    } else if (value.length < len) {
      out = value;
      while (out.length < len) {
        out += '0';
      }
    } else
      out = value;

    return out;
  } else {
    return value;
  }
}

export const getLang = () => {
  switch (i18next.language) {
    case 'tc': return 'zh_HK';
    case 'sc': return 'zh_CN';
    default: return i18next.language;
  }
}